import { SERVER_URL } from 'src/constants/serverUrl'
import { requestPost } from 'src/legacy_modules/server/request'

// cookie がセットされる
type LoginResponse = {}

export const login = async (idToken: string, firstLogin: boolean) => {
  return await requestPost<LoginResponse>({
    url: `${SERVER_URL}/accounts/signin`,
    params: { firstLogin: firstLogin },
    idToken,
  })
}
